var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyesSaggingEyelids(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".s-saggingeyelids,.cls-4-saggingeyelids,.cls-5-saggingeyelids,.cls-6-saggingeyelids{fill:none;}.cls-2-saggingeyelids{fill:#a64daa;}.cls-3-saggingeyelids{clip-path:url(#clip-path);}.cls-4-saggingeyelids,.cls-5-saggingeyelids,.cls-6-saggingeyelids{stroke:#a64daa;}.cls-4-saggingeyelids,.cls-5-saggingeyelids{stroke-linecap:round;stroke-linejoin:round;}.cls-5-saggingeyelids{stroke-width:3px;}.cls-6-saggingeyelids{stroke-miterlimit:10;stroke-width:0.25px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-saggingeyelids",
    x: 7.79,
    y: 23.29,
    width: 91.2,
    height: 64.96
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-saggingeyelids",
    d: "M11.94,51.46a1.9,1.9,0,0,1-.61-.1,2.11,2.11,0,0,1-1.41-1.82C7.47,36.92,15.84,30.15,21.17,28.15c25.14-9.46,48.39-.73,65.36,5.65l1.69.64a1.5,1.5,0,0,1-.9,2.85C40.4,25.14,22.42,42.41,15.65,48.92,14,50.53,13,51.46,11.94,51.46ZM44.3,27A62.06,62.06,0,0,0,22.23,31a15.21,15.21,0,0,0-9.59,16.69c.3-.28.63-.59.93-.89A53.48,53.48,0,0,1,35.29,33.38c9.52-3.11,20.54-4,32.93-2.69A87,87,0,0,0,44.3,27Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3-saggingeyelids"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-saggingeyelids",
    d: "M91.06,75.13c-1-.73-9-2.92-13.25-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-saggingeyelids",
    d: "M74.7,74.77a28,28,0,0,1-12,6.15,29.26,29.26,0,0,1-9.47.5c-2.16-.19-3.8-.55-12.46-3-2.94-.82-5.41-1.53-7.21-2.05a32.25,32.25,0,0,0-6.07-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-saggingeyelids",
    d: "M65.16,80.22c1.47.23,7,1.31,8.85,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-saggingeyelids",
    d: "M32.76,56.57c-1.51,1.08-3,2.23-4.42,3.38-1,.79-2.83,2.31-5.66,4.3-3.27,2.3-6.08,4-7.94,5,1.93-.36,4.49-.89,7.48-1.72,6.33-1.76,17.31-10.85,23.41-11.26,6.53-.44,7.56-1.06,13.49,1.68,15.51,7.17,18.89,5.66,22.7,6.1a18,18,0,0,0,9.35-1.32S96,59.68,97.33,58.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-saggingeyelids",
    d: "M72.45,76.67S78.1,75.34,82.21,81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-saggingeyelids",
    d: "M58.88,81.5s3.48,1.84,2.73,5.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-saggingeyelids",
    d: "M18.87,78.62A44.34,44.34,0,0,1,27,80c3.05.81,3.89,1.39,9.85,3.49,3.7,1.3,5.59,2,8.1,2.62a58.28,58.28,0,0,0,9.46,1.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-saggingeyelids",
    d: "M74.63,74.92c.74-.67,1.83-1.65,3.18-2.8l0-.05c2.07-2.7,4-8,4-8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-saggingeyelids",
    d: "M68.5,61.49A11.87,11.87,0,1,1,47,58.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-saggingeyelids",
    d: "M76.86,63.39s9.26-.73,10.7-8.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-saggingeyelids",
    d: "M71.46,62.31s6.34-1.23,7.87-6.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-saggingeyelids",
    d: "M62.08,65.64a5,5,0,1,1-5-5h0a5,5,0,0,1,5,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5-saggingeyelids",
    d: "M59.12,58c-4.1-.72-10.18-5-24.18-11.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-saggingeyelids",
    d: "M68.91,52.77,73,47.51a.49.49,0,0,0-.08-.7.51.51,0,0,0-.31-.11H64.4a.5.5,0,0,0-.5.5.45.45,0,0,0,.1.31l4.12,5.26a.5.5,0,0,0,.7.09l.09-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-saggingeyelids",
    d: "M68.91,52.77,73,47.51a.49.49,0,0,0-.08-.7.51.51,0,0,0-.31-.11H64.4a.5.5,0,0,0-.5.5.45.45,0,0,0,.1.31l4.12,5.26a.5.5,0,0,0,.7.09Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5-saggingeyelids",
    x1: 68.51,
    y1: 49.77,
    x2: 68.51,
    y2: 41.23
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesSaggingEyelids);
export default __webpack_public_path__ + "static/media/eyes-sagging-eyelids.fe2d2418.svg";
export { ForwardRef as ReactComponent };